import algoliasearch from "algoliasearch";

window.Algolia = class {
  autocompleteElement;
  listbox;
  state;
  schoolIndex;
  autocompleteItems = [];
  hbSchoolId;

  constructor(inputElement, listbox, stateElement) {
    this.autocompleteElement = document.querySelector(inputElement);
    this.hbSchoolId = document.querySelector('[name="school_id"]');
    this.listbox = document.querySelector(listbox);
    this.state = document.querySelector(stateElement);

    const algolia = algoliasearch(
      "UXMFUFJMOI",
      "5ec5fa0f219e785bf3ed78beddcfe0f4"
    );

    this.schoolIndex = algolia.initIndex(`schools production`);
    
    if (!this.autocompleteElement || !this.listbox || !this.state) {
      console.error("Required elements not found.");
      return;
    }

    this.initAutocomplete();
    this.initListbox();
  }

  initAutocomplete() {
    this.autocompleteElement.addEventListener("input", (event) => {
      const { value } = event.target;
      const opts =
        this.state.value && this.state.value !== "Select a state"
          ? { facetFilters: `state:${this.state.value}` }
          : {};
      this.autocompleteElement.setAttribute('data-school-id', '');
      this.hbSchoolId.value = '';

      this.schoolIndex
        .search(value, opts)
        .then((hits) => {
          this.autocompleteItems = hits.hits.slice(0, 5);
          this.addListBoxItems();
        })
        .catch((err) => {
          this.autocompleteItems = [];
          this.addListBoxItems();
          console.error(err);
        });
    });
  }

  addListBoxItems() {
    this.listbox.innerHTML = "";
    this.autocompleteItems.forEach((item) => {
      const li = document.createElement("li");
      const formattedAddress = `${item.address}, ${item.city}, ${item.state} ${item.zip}`;
      li.classList.add("listbox-item");
      li.setAttribute(
        "id",
        `nri-input-menu-option---school-or-district-name--${item.id}`
      );
      li.setAttribute("data-school-id", item.id);
      li.setAttribute("role", "option");
      li.setAttribute("aria-selected", "false");
      li.innerHTML = `<div>${item.name}<p class="address">${formattedAddress}</p></div>`;
      li.addEventListener("click", () => {
        this.autocompleteElement.value = item.name;
        this.autocompleteElement.setAttribute('data-school-id', item.id);
        this.hbSchoolId.value = item.id;
        this.state.value = item.state;
        this.listbox.classList.remove("open");
      });
      this.listbox.appendChild(li);
    });
  }

  initListbox() {
    this.autocompleteElement.addEventListener("focus", () => {
      this.listbox.classList.add("open");
    });
    this.autocompleteElement.addEventListener("blur", () => {
      setTimeout(() => {
        this.listbox.classList.remove("open");
      }, 200);
    });
  }
};
